import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../../core/contentful.service';
import { Entry } from 'contentful';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-memberships',
  templateUrl: './memberships.component.html',
  styleUrls: ['./memberships.component.css']
})

export class MembershipsComponent implements OnInit {
  blmMiscellaneous: Entry<any>[] = [];
  constructor(
    private contentfulService: ContentfulService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.seo.updateTags({
      title: 'Memberships & Support',
      description: 'Join the Bayou Lacombe Museum as an annual member. Enjoy free admission, invitations to lectures, store discounts, and help preserve Louisiana heritage.',
      url: '/memberships'
    });
    this.contentfulService.getItems()
    .then(blmMiscellaneous => this.blmMiscellaneous = blmMiscellaneous);
  }
}